<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('modelingDelete') }}</h5>
                        <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                    </div>
                    <div class="modal-body">
            
            <p>{{ $t('wannaDeleteThisModeling') }}</p>
                        <p style="margin-bottom:0; color: red">{{ $t('allDataWillBeLost') }}</p>
                    </div>
                    <div class="modal-footer">
                        <button v-bind:class="[buttonLoading, syncLoading]" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            {{ $t('loading') }}
                        </button>
                        <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                            {{ $t('close') }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="deleteModeling" >
                            {{ $t('delete') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import ModelingApi from "../../../api/server/modeling";

export default {
    name: "modelingModal",
    methods: {
        close() {
            this.$parent.isModalVisible = false;
        },
        async deleteModeling() {
            this.syncLoading = "";
            await ModelingApi.modelingDelete(this.$parent.modelingToDeleteId);
            this.close();
            this.$emit("reload");
        }
    },
    data() {
        return {
            buttonLoading: 'btn btn-primary',
            syncLoading: "hidden",
            files: [],
        };
    }
};
</script>
